import {
  setDirectorRequestMessage,
  clearDirectorRequest
} from 'actions/Broadcast';
import {
  SCREEN_SHARE,
  DIRECTOR_REQUEST_CANCELLED
} from 'constants/DirectorControls';
import { withCurrentParams } from 'actions/utils';
import { BROADCAST_CANCEL_KNOCK_REQUESTS } from 'actions/Types';

function cancelPendingRequest(params) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const { knock, directorRequest } = getState();
      const requestType = params?.requestType;
      let payload = {};

      if (requestType) {
        // When we want to cancel a requestType e.g canScreenShare
        const requestFound = directorRequest.find(
          item => item?.requestType === requestType
        );
        payload = { ...requestFound };
      } else {
        // When we want to cancel a presenter knock
        payload = { ...knock };
      }

      const knockId = payload?._id;

      const action = {
        type: BROADCAST_CANCEL_KNOCK_REQUESTS,
        request: async apiClient => {
          await apiClient.broadcastKnock.cancelKnockRequests(
            teamId,
            eventId,
            broadcastId,
            {
              ids: [knockId],
              action: 'cancel'
            }
          );
          return true;
        }
      };

      if (knockId) {
        socket.emit('cancelRequests', payload);
        dispatch(action);

        if (requestType) {
          if (requestType === SCREEN_SHARE) {
            dispatch(
              setDirectorRequestMessage({
                key: requestType,
                value: DIRECTOR_REQUEST_CANCELLED
              })
            );
          } else {
            dispatch(
              setDirectorRequestMessage({
                value: '',
                key: requestType
              })
            );
          }

          dispatch(
            clearDirectorRequest({
              requestId: knockId,
              requestType
            })
          );
        }
      }
    }
  );
}

export default cancelPendingRequest;
